import React, {useRef, useLayoutEffect} from 'react';
import { TextField } from '@mui/material';

const CustomTextField = ({ value, onChange, hasFocus, maxLength=100 }) => {

    const ref = useRef();

    useLayoutEffect(() => {
        if (hasFocus) {
            ref.current.focus();
        }
    }, [hasFocus]);

    return (
            <TextField
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
                inputRef={ref}
                inputProps={{maxLength}}
            />
        )
}

export default CustomTextField;
